// Coupon type constants
export const couponTypes = {
  TIMEBASE: 'timebase',
  ACCOUNT: 'account',
  NO_DISCOUNT: 'no_discount',
  MARKETING: 'marketing',
};

// Coupon error type constants
export const couponErrorTypes = {
  INVALID_CODE: 'invalid_code',
  REACH_REDEMPTION: 'reach_redemption',
  DEFAULT: 'default',
};

// Coupon fetch status constants
export const couponFetchStatus = {
  pending: 'PENDING',
  successfully: 'SUCCESSFULLY',
  failure: 'FAILURE',
  idle: 'IDLE',
  init: 'INIT',
};

// Coupon verification block type constants
export const verifyCouponBlockTypeMap = {
  notBlock: 0,
  blockFreeTrial: 1,
};

// Coupon source type constants
export const couponSourceTypeMap = {
  threshold: 'threshold', // threshold coupon
  preload: 'preload', // AT&T coupon
  marketing: 'mt', // marketing
  partnerRefer: 'partner', // partner
  supportCoupon: 'support_coupon', // support coupon
  isSupportCoupon(type) {
    return this.supportCoupon === type;
  }
};

// Coupon discount type constants
export const couponDiscountTypeMap = {
  percentage: 1, // percentage discount
  fixedAmount: 2, // fixed discount
  thresholdAmount: 5, // threshold fixed discount
};

// Coupon use case sign constants
export const couponUseCaseSignMap = {
  softBundleNoExpire: 5, // coupon with fake no expiration date for soft bundle, same as account level coupon
};

// Coupon definition type mapping
export const couponDefinitionTypeMap = new Map([
  [1, 'mlm'],
  [2, 'mlm'],
  [3, 'marketing'],
  [4, 'cancellation'],
  [5, 'renew'],
]);

// Error message mapping for internationalization
export const errorMessageMap = {
  INVALID_CODE: 'billing.coupon.invalid_code_tips',
  REACH_REDEMPTION: 'billing.coupon.reach_limit',
  DEFAULT: 'billing.coupon.invalid_code_default',
};

// Coupon form mode constants
export const couponFormModeMap = {
  INIT: 'INIT',
  EDIT: 'EDIT',
};

// Coupon validation status type constants
export const couponValidateStatusTypeMap = {
  SUCCESS: 'Success',
  FAIL: 'Fail',
};

// Cancellation coupon source constant
export const cancellationCouponSource = 'cancel';

// Flow and plan type key constants
export const FLOW_TYPE_KEY = 'flowType';
export const PLAN_TYPE_KEY = 'type';

// Subscription level action enumeration
export const subscriptionLevelActionEnum = {
  newSubscription: 1,
  replaceSubscription: 2,
  modifySubscription: 3,
  addSingleProduct: 4,
  addReplaceSingleProduct: 5,
  isNewSubscription(value) {
    return this.newSubscription === value;
  },
  isModifiedSubscription(value) {
    return this.modifySubscription === value;
  },
  isReplaceSubscription(value) {
    return this.replaceSubscription === value;
  },
  isImmediatelyEffectiveSubscription(value) {
    return this.isModifiedSubscription(value) || this.isReplaceSubscription(value);
  },
  isAddSingleProduct(value) {
    return this.addSingleProduct === value;
  },
  isAddReplaceSingleProduct(value) {
    return this.addReplaceSingleProduct === value;
  },
  isUniversalCouponSubscription(value) {
    return this.isAddSingleProduct(value) || this.isAddReplaceSingleProduct(value);
  },
};

// Marketing campaign page query parameters
export const marketingCampaignPageQueries = ['cartid', 'coupon', 'persistCoupon', 'jointsale', 'referralCode', 'ftId', 'promotion'];

// Pro annual monthly marketing campaign limited query parameters
export const proAnnualMonthlyMarketingCampaignPageLimitedQueries = ['jointsale', 'referralCode', 'promotion', 'coupon'];

// Promotion type constants
export const PROMOTION_TYPE = {
  softBundle: 'softBundle', // soft bundle
  pureReferralCoupon: 'pureReferralCoupon', // validate by referral coupon
  coupon: 'coupon', // coupon
};

export const JOINT_SALE_QUERY_PARAM = 'jointsale'
